package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Milestone(
  public val id: String,
  public val objective_id: String,
  public val title: String,
  public val description: String?,
  public val deadline: String?,
  public val progress: Long,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
